import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export function parseHTMLMessage(message) {
  return message.replace(/\n+/g, '<br/>');
}